export const URL_GET_APPOINTMENT_LIST = "/v1/appointment/pos/site/get-appointment";

export const URL_GET_RESOURCE_LIST = "/v1/appointment/pos/site/get-resource";

export const URL_GET_WAIT_LIST = "/v1/appointment/pos/site/get-wait-list";

export const APPOINTMENT_DETAIL = "/v1/appointment/appointment/list/detail";

export const URL_CREATE_APPOINTMENT = "/v1/appointment/appointment/form/create";

export const URL_UPDATE_STATUS = "/v1/appointment/appointment/form/change-status";

export const URL_UPDATE_APPOINTMENT = "/v1/appointment/appointment/form/update";

export const URL_CREATE_BLOCK_TIME = "/v1/appointment/appointment/form/add-block-time";

export const URL_DELETE_BLOCK_TIME = "/v1/appointment/appointment/form/delete-block-time";

export const URL_CHECKOUT = "/v1/appointment/appointment/form/checkout";

export const URL_GET_APPOINTMENT_SPECIFIC_DATE = "/v1/appointment/appointment/list/specific-date";

export const URL_CHECK_UPDATE = "/v1/appointment/appointment/list/check-update";

export const LIST_SEARCH = "/v1/appointment/appointment/list/search";

export const DRAG_DROP_UPDATE_URL = "/v1/appointment/appointment/form/drag-drop-update";

export const URL_CREATE_ORDER = "/v1/appointment/pos/form/create-order";